import { render } from "./ViewTask.vue?vue&type=template&id=590c5753&scoped=true"
import script from "./ViewTask.vue?vue&type=script&lang=js"
export * from "./ViewTask.vue?vue&type=script&lang=js"

import "./ViewTask.vue?vue&type=style&index=0&id=590c5753&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590c5753"]])

export default __exports__